/* ============================================================
   HOME · NEW ARRIVALS — Fresh Drop Showcase
   Stagger reveal, tilt 3D (lerp), spotlight --mx/--my, levitación,
   ripple del CTA y quick-add AJAX (1 variante) con fallback seguro.
   Vanilla, rAF, solo transform/opacity. Respeta reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(min-width: 990px) and (pointer: fine)').matches;

  function initTilt(card) {
    if (!fine || reduce) return;
    var tilt = card.querySelector('[data-nad-tilt]');
    if (!tilt) return;
    var rx = 0, ry = 0, tx = 0, ty = 0, raf = null, rect = null, MAX = 7;
    function enter() { rect = card.getBoundingClientRect(); }
    function move(e) {
      if (!rect) rect = card.getBoundingClientRect();
      var px = (e.clientX - rect.left) / rect.width;
      var py = (e.clientY - rect.top) / rect.height;
      px = px < 0 ? 0 : px > 1 ? 1 : px;
      py = py < 0 ? 0 : py > 1 ? 1 : py;
      tx = (py - 0.5) * -2 * MAX;
      ty = (px - 0.5) * 2 * MAX;
      tilt.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      tilt.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      if (!raf) raf = requestAnimationFrame(loop);
    }
    function loop() {
      rx += (tx - rx) * 0.15; ry += (ty - ry) * 0.15;
      tilt.style.setProperty('--rx', rx.toFixed(2) + 'deg');
      tilt.style.setProperty('--ry', ry.toFixed(2) + 'deg');
      if (Math.abs(tx - rx) > 0.04 || Math.abs(ty - ry) > 0.04) raf = requestAnimationFrame(loop); else raf = null;
    }
    function leave() { tx = 0; ty = 0; rect = null; if (!raf) raf = requestAnimationFrame(loop); }
    card.addEventListener('pointerenter', enter);
    card.addEventListener('pointermove', move);
    card.addEventListener('pointerleave', leave);
  }

  function attachRipple(el) {
    el.addEventListener('click', function (e) {
      if (reduce) return;
      var r = el.getBoundingClientRect();
      var d = Math.max(r.width, r.height);
      var s = document.createElement('span');
      s.className = 'nad-ripple';
      s.style.width = s.style.height = d + 'px';
      s.style.left = (e.clientX - r.left - d / 2) + 'px';
      s.style.top = (e.clientY - r.top - d / 2) + 'px';
      el.appendChild(s);
      setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 600);
    });
  }

  /* ── Quick-add AJAX (1 variante). Usa el cart-drawer de Dawn si existe;
       si algo falla, fallback a la ficha/carrito. No rompe nada. ── */
  function initAdd(form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-nad-add-btn]');
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) { window.location.href = form.getAttribute('data-pdp') || '/cart'; return; }
      var drawer = document.querySelector('cart-drawer');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (btn) btn.classList.add('is-loading');

      var sections = [];
      try { if (drawer && typeof drawer.getSectionsToRender === 'function') sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (err) {}

      var body = { items: [{ id: idInput.value, quantity: 1 }] };
      if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function (data) {
        var done = false;
        try {
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.renderContents(data);
            if (typeof drawer.open === 'function') drawer.open();
            done = true;
          }
        } catch (err) {}
        // bubble update (best-effort)
        try {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections && data.sections['cart-icon-bubble']) {
            var tmp = document.createElement('div'); tmp.innerHTML = data.sections['cart-icon-bubble'];
            var fresh = tmp.querySelector('.shopify-section') || tmp.firstElementChild;
            if (fresh) bubble.innerHTML = fresh.innerHTML;
          }
        } catch (err) {}

        if (btn) { btn.classList.remove('is-loading'); btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1800); }
        if (!done && !drawer) {
          // sin drawer: notifica suave y deja la cifra; no forzamos navegación
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      }).catch(function () {
        if (btn) btn.classList.remove('is-loading');
        window.location.href = form.getAttribute('data-pdp') || '/cart';
      });
    });
  }

  function initSection(root) {
    if (!root || root.__nadInit) return;
    root.__nadInit = true;

    if (!reduce) { root.classList.add('nad--reveal', 'nad-float-on'); }

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-nad-card]'));
    cards.forEach(initTilt);
    root.querySelectorAll('[data-nad-ripple]').forEach(attachRipple);
    root.querySelectorAll('form[data-nad-add]').forEach(initAdd);

    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (es, obs) {
        es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); obs.unobserve(en.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    } else {
      cards.forEach(function (c) { c.classList.add('is-in'); });
    }
  }

  function initAll() { document.querySelectorAll('[data-nad]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-nad]') || (e.target.matches && e.target.matches('[data-nad]') ? e.target : null);
    if (root) initSection(root);
  });
})();
